const ONES = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
];

const TENS = [
  "",
  "",
  "twenty",
  "thirty",
  "forty",
  "fifty",
  "sixty",
  "seventy",
  "eighty",
  "ninety",
];

const SCALES = ["", "thousand", "million", "billion", "trillion"];

/** Convert 0..999 into its component words (no scale word). */
function threeDigitWords(n: number): string[] {
  const words: string[] = [];
  const hundreds = Math.floor(n / 100);
  const rest = n % 100;
  if (hundreds > 0) {
    words.push(ONES[hundreds]!, "hundred");
  }
  if (rest > 0) {
    if (rest < 20) {
      words.push(ONES[rest]!);
    } else {
      words.push(TENS[Math.floor(rest / 10)]!);
      const unit = rest % 10;
      if (unit > 0) words.push(ONES[unit]!);
    }
  }
  return words;
}

/**
 * Read a non-negative integer as a person would say it — "2024" becomes
 * ["two", "thousand", "twenty", "four"]. Returns null for values that cannot
 * be rendered (negative, non-finite, or beyond the supported scale).
 */
export function numberToWords(value: number): string[] | null {
  if (!Number.isInteger(value) || value < 0) return null;
  if (value === 0) return ["zero"];

  const groups: number[] = [];
  let remaining = value;
  while (remaining > 0) {
    groups.push(remaining % 1000);
    remaining = Math.floor(remaining / 1000);
  }
  if (groups.length > SCALES.length) return null;

  const words: string[] = [];
  for (let g = groups.length - 1; g >= 0; g--) {
    const group = groups[g]!;
    if (group === 0) continue;
    words.push(...threeDigitWords(group));
    if (g > 0) words.push(SCALES[g]!);
  }
  return words;
}
